import dayjs from 'dayjs';

/** { from, to } as YYYY-MM-DD, inclusive, ending today. */
export const rangeForDays = (days) => ({
  from: dayjs().subtract(days - 1, 'day').format('YYYY-MM-DD'),
  to: dayjs().format('YYYY-MM-DD'),
});

/** One bar per day of the range, zero-filled. rows: [{ day: 'YYYY-MM-DD', ...values }] */
export function dailySeries(range, rows, pick) {
  const byDay = new Map((rows || []).map((r) => [r.day, r]));
  const out = [];
  for (let d = dayjs(range.from); !d.isAfter(dayjs(range.to)); d = d.add(1, 'day')) {
    const key = d.format('YYYY-MM-DD');
    out.push({ label: d.format('D MMM'), tooltipLabel: d.format('ddd, D MMM YYYY'), ...pick(byDay.get(key)) });
  }
  return out;
}
